<template>
	<div v-if="contentLoaded">
		<ModalDialog
			:buttons="[[{name: 'ok', caption: $t('ok'), classes: 'btn-success', clickFn: okClickedHandler}]]"
			@escKeyPressed="escKeyPressedHandler"
			size="lg">
			<template v-slot:title>{{ $t('modal_show_versions_document_link_title') + ": " + item.title }}</template>
			<template v-slot:body>
				<template>
					<div class="position-relative">
						<div class="modal-dialog-header sticky-top row mb-2">
							<div class="col-1 col-form-label">{{ $t('version') }}</div>
							<div class="col-3 col-form-label d-flex">
								<div class="flex-grow-1">{{ $t('date_editor') }}</div>
								<div class="flex-grow-0 text-right">{{ $t('document_size') }}</div>
							</div>
							<div class="col-8 col-form-label">{{ $t('version_comment') }}</div>
						</div>
						<ul class="list-unstyled">
							<template v-for="version in item.documentVersions">
								<li class="row has-elements-visible-on-hover"  :key="version.id">
									<div class="col-1 col-form-label text-nowrap">
										{{ version.versionLabel }}<i class="item-external-link fas fa-external-link-alt clickable clickable--no-hover ml-2 text-primary visible-on-hover" @click="openLinkPDF(version)"  :title="$t('openDocument')"></i>
									</div>
									<div class="col-3 col-form-label">
										<div class="row">
											<div class="col-6">{{ version.modified.format('YYYY.MM.DD') }}</div>
											<div class="col-6 text-right text-nowrap">{{ version.size }}</div>
											<div class="col-12">{{ version.editor.displayName }}</div>
										</div>
									</div>
									<div class="col-8 col-form-label">
										<div v-if="version.description">{{ version.description }}</div>
										<div v-if="version.checkInComment" class="d-flex font-weight-semilight">
											<div class="flex-grow-0"><i class="far fa-comment flip-h text-secondary mr-1"></i></div>
											<div class="flex-grow-1">{{ version.checkInComment }}</div>
										</div>
									</div>
								</li>
							</template>
						</ul>
					</div>
				</template>
			</template>
		</ModalDialog>
	</div>
	<div v-else>
		<ModalMessage :message="$t('loading')"></ModalMessage>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { utilities } from '../resources/utilities.js';
import ModalDialog from './ModalDialog.vue';
import ModalMessage from '../components/ModalMessage.vue';

export default {
	props: ['item'],

	components: {
		ModalDialog,
		ModalMessage,
	},

	data() {
		return {
			contentLoaded: false,
		};
	},

	computed: {
		...mapState(['stateMachine', 'documentationDocumentLibraries', 'currentUser']),
	},

	methods: {
		...mapActions(['getDocumentVersions']),

		escKeyPressedHandler() {
			this.$emit('okClicked');
		},

		okClickedHandler() {
			this.$emit('okClicked');
		},

		openLinkPDF(version) {
			const url = this.item.getDocumentVersionUrl(version);
			if (this.$AuthService.isExternalUser()) {
				utilities.downloadSharepointFile(url, this.item.title);
			} else {
				window.open(url, '_blank').focus();
			}
		},
	},

	created() {
		this.contentLoaded = false;
		let spList = this.documentationDocumentLibraries.find((ddl) => ddl.internalName(this.stateMachine.testMode) === this.item.libraryName);
		this.getDocumentVersions({
			item: this.item,
			spList,
		}).then(() => {
			this.contentLoaded = true;
			this.item.documentVersions.sort(utilities.multiCriteriaSort(['modified'], -1));
		}).catch((e) => {
			console.error('[PRODUCTS] ShowVersionHistory.getDocumentsVersions failed', e);
		});
	},
};
</script>
